import React from 'react';
import { Link } from 'react-router-dom';
import { FiFacebook, FiInstagram, FiLinkedin, FiSend, FiTwitter } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="mt-20 border-t border-slate-200 bg-white">
      <div className="sc-container py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 xl:grid-cols-5">
          <div className="xl:col-span-2">
            <h3 className="mb-3 text-xl font-bold text-[#1A1A1A]">ShopCircuit</h3>
            <p className="max-w-md text-sm leading-relaxed text-slate-500">
              Premium electronics and lifestyle products, curated for modern shoppers who care
              about design, quality and trusted fulfillment.
            </p>
            <div className="mt-5 flex max-w-md overflow-hidden rounded-full border border-slate-200 bg-slate-50">
              <input
                type="email"
                placeholder="Get campaign updates"
                className="w-full border-none bg-transparent px-4 py-3 text-sm outline-none"
              />
              <button className="sc-hover-smooth m-1 inline-flex items-center gap-2 rounded-full bg-[#DB4444] px-4 text-sm font-semibold text-white hover:bg-[#b93333]">
                Subscribe
                <FiSend size={14} />
              </button>
            </div>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-bold uppercase tracking-wider text-[#1A1A1A]">Company</h4>
            <ul className="space-y-2 text-sm text-slate-500">
              <li>
                <Link to="/about" className="sc-hover-smooth hover:text-[#DB4444]">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="sc-hover-smooth hover:text-[#DB4444]">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/products" className="sc-hover-smooth hover:text-[#DB4444]">
                  Shop
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-bold uppercase tracking-wider text-[#1A1A1A]">Account</h4>
            <ul className="space-y-2 text-sm text-slate-500">
              <li>
                <Link to="/profile" className="sc-hover-smooth hover:text-[#DB4444]">
                  My Profile
                </Link>
              </li>
              <li>
                <Link to="/orders" className="sc-hover-smooth hover:text-[#DB4444]">
                  Orders
                </Link>
              </li>
              <li>
                <Link to="/wishlist" className="sc-hover-smooth hover:text-[#DB4444]">
                  Wishlist
                </Link>
              </li>
              <li>
                <Link to="/cart" className="sc-hover-smooth hover:text-[#DB4444]">
                  Cart
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-bold uppercase tracking-wider text-[#1A1A1A]">Follow</h4>
            <div className="flex items-center gap-2">
              <button type="button" className="sc-hover-smooth rounded-full border border-slate-200 p-2.5 text-slate-500 hover:border-[#DB4444] hover:text-[#DB4444]">
                <FiFacebook size={15} />
              </button>
              <button type="button" className="sc-hover-smooth rounded-full border border-slate-200 p-2.5 text-slate-500 hover:border-[#DB4444] hover:text-[#DB4444]">
                <FiTwitter size={15} />
              </button>
              <button type="button" className="sc-hover-smooth rounded-full border border-slate-200 p-2.5 text-slate-500 hover:border-[#DB4444] hover:text-[#DB4444]">
                <FiInstagram size={15} />
              </button>
              <button type="button" className="sc-hover-smooth rounded-full border border-slate-200 p-2.5 text-slate-500 hover:border-[#DB4444] hover:text-[#DB4444]">
                <FiLinkedin size={15} />
              </button>
            </div>
            <p className="mt-4 text-sm text-slate-500">support@shopcircuit.com</p>
            <p className="text-sm text-slate-500">+88015-88888-9999</p>
          </div>
        </div>

        <div className="mt-12 border-t border-slate-100 pt-5 text-center text-xs text-slate-500">
          <p>Copyright ShopCircuit 2026. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
